export default function loadImage(file: Blob, signal?: AbortSignal): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
        const image = new Image();
        const url = URL.createObjectURL(file);
        const cleanup = () => {
            URL.revokeObjectURL(url);
            signal?.removeEventListener('abort', abort);
            image.onload = image.onerror = null;
        };
        const fail = (error: Error) => { cleanup(); image.removeAttribute('src'); reject(error); };
        const abort = () => fail(new DOMException('Upload cancelled', 'AbortError'));
        image.onload = () => { cleanup(); resolve(image); };
        image.onerror = () => fail(new Error('Unable to decode image'));
        signal?.addEventListener('abort', abort, { once: true });
        if (signal?.aborted) { abort(); return; }
        image.src = url;
    });
}
